// extracted by mini-css-extract-plugin
export default {"bodyNotFound":"NotFound_bodyNotFound__vtdWe","notfound":"NotFound_notfound__5PJbn","notfound404":"NotFound_notfound404__zF-YO","notfound-404":"NotFound_notfound-404__u8EAk"};